import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "checkout-pending-icon",
  viewBox: "1 -8 12 20",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "2",
  cy: "2",
  r: "1.5"
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "2",
  cy: "2",
  r: "1.5",
  transform: "translate(5 0)"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "2",
  cy: "2",
  r: "1.5",
  transform: "translate(10 0)"
}, null, -1);
const _hoisted_5 = [_hoisted_2, _hoisted_3, _hoisted_4];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5);
}